import type { User } from "@domaddress/shared";
import ContactsPage from "./ContactsPage";

export default function LeveranciersPage({ user }: { user: User | null }) {
  return (
    <ContactsPage
      user={user}
      apiPath="/api/leveranciers"
      title="Leveranciers"
      singularLabel="leverancier"
      pluralLabel="leveranciers"
      importPath="/leveranciers/importeren"
      pageKey="leveranciers"
    />
  );
}
